import { render } from "./PendingInpectionList.vue?vue&type=template&id=8e547b5c&scoped=true"
import script from "./PendingInpectionList.vue?vue&type=script&lang=js"
export * from "./PendingInpectionList.vue?vue&type=script&lang=js"

import "./PendingInpectionList.vue?vue&type=style&index=0&id=8e547b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e547b5c"]])

export default __exports__